import {
  useEventCallback,
  useFormSelector,
  UserContext,
} from '@eas/common-web';
import Button from '@material-ui/core/Button';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import React, { useContext } from 'react';
import { ExitProcessAction } from '../../../components/process/process-actions';
import { ProcessActionsProps } from '../../../components/process/process-types';
import { SubjectRegistrationType } from '../../../models';
import { ProcessForm } from '../subject-requests-types';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      marginLeft: theme.spacing(1),
      float: 'right',
    },
    actionsContainer: {
      marginBottom: theme.spacing(2),
    },
  })
);

export function StepTypeActions({
  activeStep,
  handleNext,
  handleBack,
  handleExit,
  handleMoveToStep,
}: ProcessActionsProps<ProcessForm>) {
  const classes = useStyles();
  const { user } = useContext(UserContext);

  const { type } = useFormSelector((data: ProcessForm) => ({
    type: data.type,
  }));

  const handleNextWithCheck = useEventCallback(() => {
    if (
      user?.hasNiaExternalId &&
      type === SubjectRegistrationType.NATURAL_PERSON_REGISTRATION
    ) {
      handleMoveToStep(2);
    } else {
      handleNext();
    }
  });

  return (
    <div className={classes.actionsContainer}>
      <div>
        <Button
          variant="contained"
          color="primary"
          onClick={handleNextWithCheck}
          className={classes.button}
          disableElevation
        >
          Další
        </Button>
        <Button
          disabled={activeStep === 0}
          onClick={handleBack}
          className={classes.button}
          disableElevation
        >
          Předchozí
        </Button>
        <ExitProcessAction handleExit={handleExit} />
      </div>
    </div>
  );
}
